module.exports = {
  API_OPENSEARCH_URL: `${process.env.REACT_APP_OPENSEARCH_URL}api/`,
  API_BASE_URL: `${process.env.REACT_APP_API_BASE_URL}api/`,
  API_UPLOADS_URL: `${process.env.REACT_APP_API_FILES_URL}storage/`,
  API_ASSETS_IMAGES_URL: `${process.env.REACT_APP_API_BASE_URL}assets/images/`,
  API_CMS_BG_IMAGES_URL: `${process.env.REACT_APP_API_BASE_URL}uploads/images/`
};
